/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_TaglineInputs */

const en_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team's operating system`)
};

const ar_app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظام تشغيل فريقك`)
};

/**
* | output |
* | --- |
* | "Your team's operating system" |
*
* @param {App_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const app_tagline = /** @type {((inputs?: App_TaglineInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_TaglineInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_tagline(inputs)
	return ar_app_tagline(inputs)
});